export default __webpack_public_path__ + "images/QJ.27b6cba.png";